import { gql, useQuery } from '@apollo/client'
import { getCacheableContext } from '@emico-utils/graphql-data-utils'

import { SizeTable } from '../../graphql/schema.generated'

const query = gql`
    query SizeTables {
        sizeTables {
            description
            name
            note
            rows {
                cells {
                    isHead
                    content
                }
            }
            uid
            urls {
                label
                type
                url
            }
        }
    }
`

interface GetSizeTablesData {
    sizeTables: SizeTable[]
}

const useSizeTablesQuery = () => {
    const { data, ...rest } = useQuery<GetSizeTablesData>(query, {
        context: getCacheableContext(),
    })
    return {
        data: data?.sizeTables ?? [],
        ...rest,
    }
}

export const useSizeTables = () => {
    const { data, loading } = useSizeTablesQuery()

    return {
        data,
        loading,
        uids: data?.map((d) => ({ uid: d.uid, name: d.name })),
    }
}
